module.exports = __webpack_public_path__ + "static/location-1f5f80bd1bf8a1827b0b16b05248fb2c.png";